module.exports = __webpack_public_path__ + "static/img/aluminum-scrap_256.7d03492.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aluminum-scrap_256.png
// module id = 2RsS
// module chunks = 0